module.exports = __webpack_public_path__ + "img/logo.01de98de.png";